module.exports = __webpack_public_path__ + "img/35.a43f4807.gif";